export default __webpack_public_path__ + "static/media/mongodb.369dd398.png";